module.exports = require("@angular/http");


//////////////////
// WEBPACK FOOTER
// external "@angular/http"
// module id = 3
// module chunks = 0